import { render, staticRenderFns } from "./CourseBuilderVideo.vue?vue&type=template&id=be24bafe&scoped=true&"
import script from "./CourseBuilderVideo.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be24bafe",
  null
  
)

export default component.exports